import React from "react";
import { Link } from "react-router-dom";
import { Building2, Waypoints, Activity, ArrowRight } from "lucide-react";

const categories = [
  { icon: Building2, name: "Building Expansion Joints", desc: "Floor, wall, and ceiling cover systems for commercial and institutional structures.", anchor: "building" },
  { icon: Waypoints, name: "Bridge Expansion Joints", desc: "Finger joints, modular joints, and strip seals for highway and bridge decks.", anchor: "bridge" },
  { icon: Activity, name: "Seismic Joint Systems", desc: "Wide-gap seismic covers engineered for the Philippines' earthquake-prone zones.", anchor: "seismic" },
];

export default function CategoryPreview() {
  return (
    <section className="bg-[#0A0A0A] clip-diagonal-top py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <p className="font-tech font-semibold uppercase tracking-[0.2em] text-[#FF4D5E] text-sm mb-3">Product Systems</p>
        <h2 className="font-heading font-extrabold uppercase text-white text-4xl md:text-5xl tracking-wide mb-14">
          Movement Joint Solutions
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {categories.map((c) => (
            <Link key={c.anchor} to={`/products#${c.anchor}`}
              className="group bg-[#171717] border border-white/10 p-10 transition-all duration-300 hover:-translate-y-1 hover:border-[#E4001C]/60">
              <c.icon className="w-10 h-10 text-[#E4001C] mb-6" />
              <h3 className="font-tech font-semibold uppercase tracking-widest text-white text-xl mb-4">{c.name}</h3>
              <p className="text-[#A8ADB4] text-sm leading-relaxed mb-8">{c.desc}</p>
              <span className="inline-flex items-center gap-2 font-tech font-semibold uppercase tracking-widest text-sm text-white group-hover:text-[#E4001C] transition-colors">
                Explore <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}